import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {IndexPage as DashboardPage} from "../features/dashboard/pages/IndexPage.tsx";
import {ApplicationsLayout} from "../features/applications/layout.tsx";
import {OrganizationsLayout} from "../features/organizations/layout.tsx";
import {AccountsLayout} from "../features/accounts/layout.tsx";
import {PlaybooksLayout} from "../features/playbooks/layout.tsx";
import {ExecutionsLayout} from "../features/executions/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {IndexPage as AnalyticsPage} from "../features/analytics/pages/IndexPage.tsx";
import {ApplicationScreenshotsLayout} from "../features/application-screenshots/layout.tsx";
import {RedirectToDevOps} from "../utils/RedirectToDevOps.tsx";
import {RedirectToDirectory} from "../utils/RedirectToDirectory.tsx";
import {RedirectToPlatform} from "../utils/RedirectToPlatform.tsx";
import {RequirePermission} from "../utils/RequirePermission.tsx";
import {NotAuthorizedPage} from "../features/home/pages/NotAuthorizedPage.tsx";
import {rbacActions} from "./rbac/actions.ts";


export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        // FNP-826: admin-only, like every feature route; the pool is shared
        // with the portal. Every other denial redirects here, so this one
        // renders an explicit page instead of redirecting again.
        path: 'dashboard',
        element: <RequireAuth>
            <RequirePermission action={rbacActions.ViewDashboard} denied={<NotAuthorizedPage/>}>
                <DashboardPage/>
            </RequirePermission>
        </RequireAuth>
    }, {
        path: 'applications/*',
        element: <RequireAuth><ApplicationsLayout/></RequireAuth>
    }, {
        path: 'organizations/*',
        element: <RequireAuth><OrganizationsLayout/></RequireAuth>
    }, {
        path: 'accounts/*',
        element: <RequireAuth><AccountsLayout/></RequireAuth>
    }, {
        path: 'playbooks/*',
        element: <RequireAuth><PlaybooksLayout/></RequireAuth>
    }, {
        path: 'executions/*',
        element: <RequireAuth><ExecutionsLayout/></RequireAuth>
    }, {
        path: 'application-screenshots/*',
        element: <RequireAuth><ApplicationScreenshotsLayout/></RequireAuth>
    }, {
        path: 'analytics/*',
        // Same action as the Analytics menu item, so the link and the route agree.
        element: <RequireAuth>
            <RequirePermission action={rbacActions.ListUsers} denied={<NotAuthorizedPage/>}>
                <AnalyticsPage/>
            </RequirePermission>
        </RequireAuth>,
    },
    // FNP-1636: these four modules moved to the DevOps application. Their old
    // Console URLs forward to the same page there. No RequireAuth: nothing is
    // rendered here, and the DevOps app guards its own routes.
    ...['pipelines/*', 'code-pipelines/*', 'code-repositories/*', 'deployment-account-groups/*']
        .map((path) => ({path, element: <RedirectToDevOps/>})),
    // FNP-1649: Platform Controls moved to the platform application. Same
    // forwarding, same reason for no RequireAuth.
    {path: 'platform-controls/*', element: <RedirectToPlatform/>},
    // FNP-2017: user management moved to Flexi Directory. Same forwarding,
    // same reason for no RequireAuth.
    {path: 'users/*', element: <RedirectToDirectory/>},
    ]
}]